module.exports = __webpack_public_path__ + "7f06d69ff1c69c6c7c71e9a48f53f002.svg";